module.exports = __webpack_public_path__ + "img/Succes-Icons.00cd913b.svg";